export const formFields = [
  {
    section: "section 1",
    name: "ps3PatientPaySchName",
    label: "Schedule",
    fieldLabel: "PS3 Patient Pay Sch Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [2, 1],
  },
  {
    section: "section 1",
    name: "ps3PatientPaySchDesc",
    label: "Description",
    fieldLabel: "PS3 Patient Pay Sch Desc",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-only, View: Read-only",
    position: [3, 1],
  },
  {
    section: "section 1",
    name: "ppcSeqNbr",
    label: "Sequence",
    fieldLabel: "PPC Seq Nbr",
    type: "number",
    fractionDigits: 0,
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 1, message: "MIN_1" },
      max: { value: 999, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [4, 1],
  },
  {
    section: "section 1",
    name: "ppcPatientPayTable",
    label: "Patient Pay Table",
    fieldLabel: "PPC Patient Pay Table",
    type: "lookup",
    externalProgram: { default: "RCPS4035" },
    params: {
      lookupType: "local",
      fieldMapping: {
        default: [
          {
            source: "ppcPatientPayTable",
            target: "ps4PtPaySchTableName",
            paramDataKey: "ps4PtPaySchTableName",
            legacy: "ps4PtPaySchTableName",
          },
          {
            source: "wrkDescription25",
            target: "ps4PatPayDescription",
            paramDataKey: "NA",
            legacy: "ps4PatPayDescription",
          },
        ],
      },
    },
    options: { maxLength: { value: 13, message: "MAXLENGTH_13" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [5, 1],
  },
  {
    section: "section 1",
    name: "wrkDescription25",
    label: "",
    fieldLabel: "WRK Description 25",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [5, 2],
  },
  {
    section: "section 1",
    name: "ppcEgwp04PatPayTbl",
    label: "Troop Accum Code 04 PatPay",
    fieldLabel: "PPC EGWP04 Pat Pay Tbl",
    type: "lookup",
    externalProgram: { default: "RCPS4035" },
    params: {
      lookupType: "local",
      fieldMapping: {
        default: [
          {
            source: "ppcEgwp04PatPayTbl",
            target: "ps4PtPaySchTableName",
            paramDataKey: "ps4PtPaySchTableName",
          },
          {
            source: "wrkDescription251",
            target: "ps4PatPayDescription",
            paramDataKey: "NA",
          },
        ],
      },
    },
    options: { maxLength: { value: 13, message: "MAXLENGTH_13" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 1],
  },
  {
    section: "section 1",
    name: "wrkDescription251",
    label: "",
    fieldLabel: "WRK Description 25 1",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [6, 2],
  },
  {
    section: "section 1",
    name: "ppcClaimStatus",
    label: "Claim Status",
    fieldLabel: "PSC Claim Status",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
  },
  {
    section: "section 1",
    name: "ppcCompound",
    label: "Compound",
    fieldLabel: "PPC Compound",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "section 1",
    name: "ppcSpecialtyFlag",
    label: "Speciality",
    fieldLabel: "PPC Specialty Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "section 1",
    name: "ppcTier",
    label: "Tier",
    fieldLabel: "PPC Tier",
    type: "text",
    options: {
      maxLength: { value: 2, message: "MAXLENGTH_2" },
      required: { value: true, message: "REQUIRED" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "section 1",
    name: "ppcThirdPartyException",
    label: "Third Party Exception",
    fieldLabel: "PPC Third Party Exception",
    type: "lookup",
    externalProgram: { default: "RC3EX900" },
    viewMode: "text",
    params: {
      lookupType: "external",
      viewMode: "text",
      fieldMapping: {
        default: [
          {
            source: "ppcThirdPartyException",
            target: "thirdPartyException",
            paramDataKey: "list",
            legacy: "thirdPartyException",
          },
          {
            source: "ppcThirdPartyExceptionDesc",
            target: "description",
            paramDataKey: "NA",
            legacy: "description",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "THIRD_PARTY",
    },
    options: {
      maxLength: { value: 1, message: "MAXLENGTH_1" },
      required: { value: true, message: "REQUIRED" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 1],
  },
  {
    section: "section 1",
    name: "ppcThirdPartyExceptionDesc",
    label: "",
    fieldLabel: "PPC Third Party Exception Desc",
    type: "text",
    options: {},
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [11, 9],
  },
  {
    section: "section 1",
    name: "ppcOtcIndicator",
    label: "OTC",
    fieldLabel: "PPC OTC Indicator",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 1],
  },
  {
    section: "section 1",
    name: "ppcProductSelectionCde",
    label: "PSC",
    fieldLabel: "PPC Product Selection Cde",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 1],
  },
  {
    section: "section 1",
    name: "ppcFillNumber",
    label: "Fill Number",
    fieldLabel: "PPC Fill Number",
    type: "text",
    options: {
      maxLength: { value: 2, message: "MAXLENGTH_2" },
      required: { value: true, message: "REQUIRED" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 1],
  },
  {
    section: "section 1",
    name: "ppcFillNumberDesc",
    label: "",
    fieldLabel: "WRK Description 25 4",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [14, 2],
  },
  {
    section: "section 1",
    name: "ppcPlanDrugSts",
    label: "Drug Status",
    fieldLabel: "Plan Default Drug Status",
    type: "dropdown",
    dropdownCondition: "Vld Plan Val-Scr(Excpt a)",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 1],
  },
  {
    section: "section 1",
    name: "ppcMedicaidDualStsCde",
    label: "Medicaid Dual Status Code",
    fieldLabel: "DUV Mcd Dual Sts Cde",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 1],
  },
  {
    section: "section 1",
    name: "ppcProcessingQualifier",
    label: "Processing Qualifier",
    fieldLabel: "PPC Processing Qualifier",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 1],
  },

  {
    section: "section 1",
    name: "ppcMaxDaysSupply",
    label: "Max Days",
    fieldLabel: "PPC Max Days Supply",
    type: "text",
    options: { maxLength: { value: 3, message: "MAXLENGTH_3" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
    displayConditions: [
      {
        dependentField: "ppcProcessingQualifier",
        dependentFieldValues: ["R", "Q", "S"],
        fieldNature: "Read-only",
        shouldFieldValuesIncluded: true,
      },
    ],
  },

  {
    section: "section 1",
    name: "ppcMaxQuantity",
    label: "Max Qty",
    fieldLabel: "PPC Max Quantity",
    type: "text",
    options: { maxLength: { value: 3, message: "MAXLENGTH_3" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 1],
    displayConditions: [
      {
        dependentField: "ppcProcessingQualifier",
        dependentFieldValues: ["R", "Q", "S"],
        fieldNature: "Read-only",
        shouldFieldValuesIncluded: true,
      },
    ],
  },

  {
    section: "section 1",
    name: "ppcMessageCode",
    label: "Message Code",
    fieldLabel: "PPC Message Code",
    type: "lookup",
    externalProgram: { default: "RCMSG002" },
    params: {
      lookupType: "external",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "ppcMessageCode",
            target: "code",
            paramDataKey: "searchCriteria",
            legacy: "msgMessageCde",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "MESSAGE_CODE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 1],
  },
  {
    section: "section 1",
    name: "ppcMessageType",
    label: "Message Type",
    fieldLabel: "PNO Message Type",
    type: "dropdown",
    dropdownCondition: "Reject and Blank",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 1],
  },

  {
    section: "Table Format",
    type: "label",
    label: "-",
    position: [22, 1],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "Code",
    position: [22, 2],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "List",
    position: [22, 3],
    format: "columnHeader",
  },
  {
    section: "Table Format",
    type: "label",
    label: "Multi Source",
    position: [23, 1],
  },
  {
    section: "Table Format",
    name: "ppcMultiSource",
    label: "",
    fieldLabel: "PPC Multi-Source",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 2],
  },
  {
    section: "Table Format",
    name: "ppcMultiSourceList",
    label: "",
    fieldLabel: "PPC Multi-Source List",
    type: "lookup",
    externalProgram: { default: "RCMSL005" },
    params: {
      lookupType: "external",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "ppcMultiSourceList",
            target: "list",
            paramDataKey: "searchCriteria",
            legacy: "mslMultiSourceList",
          },
          {
            source: "mslMultiSourceLstDesc",
            target: "description",
            paramDataKey: "NA",
            legacy: "description",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "MULTI_SOURCE",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 3],
  },
  {
    section: "Table Format",
    name: "mslMultiSourceLstDesc",
    label: "",
    fieldLabel: "MSL Multi-Source Lst Desc",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [23, 4],
  },

  {
    section: "Table Format",
    type: "label",
    label: "Formulary Status",
    position: [24, 1],
  },
  {
    section: "Table Format",
    name: "ppcFormularyStatus",
    label: "",
    fieldLabel: "PPC Formulary Status",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 2],
  },
  {
    section: "Table Format",
    name: "ppcFormularyStatusList",
    label: "",
    fieldLabel: "PPC Formulary Status List",
    type: "lookup",

    externalProgram: { default: "RCFS1005" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "ppcFormularyStatusList",
            target: "list",
            paramDataKey: "searchCriteria",
            legacy: "fs1List",
          },
          {
            source: "fs1Description",
            target: "description",
            paramDataKey: "NA",
            legacy: "description",
          },
        ],
      },
    },
    options: { maxLength: { value: 13, message: "MAXLENGTH_13" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 3],
  },
  {
    section: "Table Format",
    name: "fs1Description",
    label: "",
    fieldLabel: "FS1 Description",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [24, 4],
  },

  {
    section: "Table Format",
    type: "label",
    label: "State",
    position: [25, 1],
  },
  {
    section: "Table Format",
    name: "ppcStateQualifier",
    label: "",
    fieldLabel: "PPC State Qualifier",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 2],
  },
  {
    section: "Table Format",
    name: "stlStateListName",
    label: "",
    fieldLabel: "STL State List Name",
    type: "lookup",
    externalProgram: { default: "RCSTL005" },
    viewType: "legacy",
    params: {
      lookupType: "external",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "stlStateListName",
            target: "list",
            paramDataKey: "searchCriteria",
            legacy: "stlStateListName",
          },
          {
            source: "stlStateListDesc",
            target: "description",
            paramDataKey: "NA",
            legacy: "stlStateListDesc",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "STATE_LIST",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 3],
  },
  {
    section: "Table Format",
    name: "stlStateListDesc",
    label: "",
    fieldLabel: "STL State List Desc",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-Only, Change: Read-Only, View: Read-only",
    position: [25, 4],
  },

  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-Only, View: Read-only",
    position: [26, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-Only, View: Read-only",
    position: [26, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-Only, View: Read-only",
    position: [26, 3],
  },
];
